module.exports = __webpack_public_path__ + "media/images/smart_phone/info_1-eb24b698e3a0c7dceb12d36830c70371.png";